module.exports = __webpack_public_path__ + "static/media/Camera.99f1baca.svg";